import React, { useContext, Fragment } from 'react';
import PaxDispatch from '../PaxDispatch';
import RoomDetail from './RoomDetail';
import { SET_EDIT_MODE, REMOVE_ROOM } from '../../Constant/constants';
import PaxInfo from './PaxInfo';
import WarningMessage from './WarningMessage';
import { faOnEditChanges, faOnRemoveRoom } from '../../analytics-services';
import './Room.css';

const Room = ({ room, roomIndex, isEdit, removable = true, paxConfig, omniture }) => {
  const dispatch = useContext(PaxDispatch);
  const roomNumber = roomIndex + 1;
  const handleRemoveRoom = () => {
    faOnRemoveRoom(roomIndex);
    dispatch({ type: REMOVE_ROOM, index: roomIndex });
  };

  const handleEditClick = () => {
    faOnEditChanges(roomIndex);
    dispatch({ type: SET_EDIT_MODE, index: roomIndex });
  };
  return (
    <>
      {isEdit && (
        <WarningMessage
          message={`Maximum<span class="latoBlack">
                ${paxConfig?.maxPaxAllowed ? paxConfig.maxPaxAllowed : 4} guests
              </span>are allowed in this room
            `}
        />
      )}
      <div className="room-container">
        <div className="room-info">
          <p className="latoBlack font12 greyText capText">{`Room ${roomNumber}`}</p>
          {removable && (
            <p className="room_removeBtn" onClick={handleRemoveRoom}>
              Remove
            </p>
          )}
        </div>
        <div className="room-component-container">
          {!isEdit ? (
            <>
              <PaxInfo {...room} />
              <span className="room_editBtn" onClick={handleEditClick}>
                Edit
              </span>
            </>
          ) : (
            <RoomDetail {...room} roomIndex={roomIndex} paxConfig={paxConfig} omniture={omniture} />
          )}
        </div>
      </div>
    </>
  );
};

export default Room;
